var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"dot",attrs:{"viewBox":"0 0 8 8"}},[_c('circle',{staticClass:"outer",attrs:{"cx":"4","cy":"4","r":"4"}}),_c('circle',{staticClass:"center",class:_vm.selected && 'selected',attrs:{"cx":"4","cy":"4","r":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }